import errorModule from 'src/js/modules/error';
import publishingServiceClient from '../../publishing-service-client/service-client';
import statusNames from '../constants/status-names';
import status from '../../status';
import resolveServiceError from '../../../common/helpers/resolve-service-error';

const unpublishSite = (siteId) => async (dispatch) => {
  const publishingService = publishingServiceClient.get();

  dispatch(status.actions.setStatus(statusNames.SITE_UNPUBLISH, status.constants.LOADING));

  try {
    const response = await publishingService.unpublishSite(siteId);

    dispatch(status.actions.setStatus(statusNames.SITE_UNPUBLISH, status.constants.SUCCEEDED));

    return response;
  } catch (e) {
    errorModule.operations.catchError(e);
    const error = await resolveServiceError(e);

    console.error(error);
    dispatch(status.actions.setStatus(statusNames.SITE_UNPUBLISH, status.constants.FAILED));

    throw error;
  }
};

export default unpublishSite;
